import { Stack, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { useNavigate } from 'react-router-dom'

function List3({ operations, setSelectedRows }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  // function ListTop ( { fetchOperations, operations, setSelectedRows } )
  let navigate = useNavigate()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    // let url = `&limit=${ newPageSize }&offset=${ page }`
    // fetchOperations( url )
  }
  // const handlePageChange = newPage =>
  // {
  //   setPage( newPage * rows )
  //   let url = `&limit=${ rows }&offset=${ newPage * rows }`
  //   fetchOperations( url )
  // }

  // LAP-733 (GE022): columns memoized so headerName re-evaluates on locale change
  const columns = useMemo(() => [
    // { field: 'id', headerName: 'ID', width: 90 },

    {
      field: 'CompetencesType',
      headerName: t('parcoursPro.headerType'),
      width: 90,
      flex: 1,
      editable: true,
    },

    {
      field: 'CompetencesName',
      headerName: t('parcoursPro.headerSkills'),
      flex: 1,
      width: 220,
      editable: true,
      // valueGetter: (params) => `${params.row.Marques.Marque}`,
    },
  ], [t])
  return (
    <div
      style={{
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {t('parcoursPro.titleCompetence') /* LAP-733 (GE022) */} ({operations.count})
      </Typography>

      <DataGrid
        // getRowHeight={() => 'auto'}
        // getEstimatedRowHeight={() => 200}
        sx={{ height: 700, '& .MuiToolbar-root': { alignItems: 'baseline' } }}
        rows={operations.results ? operations.results : []}
        columns={columns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        // onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        // paginationMode='server'
        // disableSelectionOnClick
        // checkboxSelection
        disableSelectionOnClick
        // onRowClick={(e) => setEventViewF(e.row.Event)}

        // onRowClick={(params, event) => {
        //   if (event.target.localName === 'div') {
        //     // window.open(params.row.Lien)
        //     navigate(`/domicile/vehicule/{}`)
        //     console.log(params)
        //   }
        // }}
      />
    </div>
  )
}
export default List3
